var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactQuestionFactory, SurveyPage, SurveyQuestionElementBase } from "survey-react-ui";
var SurveyElementEmbeddedSurvey = /** @class */ (function (_super) {
    __extends(SurveyElementEmbeddedSurvey, _super);
    function SurveyElementEmbeddedSurvey() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SurveyElementEmbeddedSurvey.prototype, "embeddedSurvey", {
        get: function () {
            return (this.props.element || this.props.question);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyElementEmbeddedSurvey.prototype, "creator", {
        get: function () {
            return this.props.creator;
        },
        enumerable: false,
        configurable: true
    });
    SurveyElementEmbeddedSurvey.prototype.render = function () {
        if (!this.embeddedSurvey)
            return null;
        var survey = this.embeddedSurvey.embeddedSurvey;
        if (!survey || !survey.currentPage)
            return null;
        return React.createElement(SurveyPage, { survey: survey, page: survey.currentPage, css: survey.css, creator: this.creator });
    };
    return SurveyElementEmbeddedSurvey;
}(SurveyQuestionElementBase));
export { SurveyElementEmbeddedSurvey };
ReactQuestionFactory.Instance.registerQuestion("embeddedsurvey", function (props) {
    return React.createElement(SurveyElementEmbeddedSurvey, props);
});
